export class PromoCodeForm {
  promo_code = '';
}
